// Each browser has its own storage (WhatsApp and Facebook open links in their own
// in-app browser), so a personal key ties your polls together across them. The
// personal link carries it in the URL hash, which browsers never send to a server.
const KEY = 'polley_key';

export function getPersonalKey() {
    let key = localStorage.getItem(KEY);
    if (!key) {
        // randomUUID is missing in older iOS in-app browsers, getRandomValues is not.
        key = crypto.randomUUID?.() ??
            Array.from(crypto.getRandomValues(new Uint8Array(16)), (b) => b.toString(16).padStart(2, '0')).join('');
        localStorage.setItem(KEY, key);
    }
    return key;
}

export function adoptPersonalKey(key) {
    if (/^[A-Za-z0-9-]{20,64}$/.test(key)) localStorage.setItem(KEY, key);
}

export function personalLink() {
    return `${window.location.origin}/me#${getPersonalKey()}`;
}

export function rememberPoll(slug, name, pollName) {
    localStorage.setItem(`poll_${slug}`, JSON.stringify({ name, pollName }));
}

export function rememberedPolls() {
    return Object.keys(localStorage)
        .filter((key) => key.startsWith('poll_'))
        .map((key) => {
            try {
                const { name, pollName } = JSON.parse(localStorage.getItem(key));
                return { slug: key.slice('poll_'.length), name: pollName || 'Unknown Poll', participantName: name };
            } catch {
                return null;
            }
        })
        .filter(Boolean);
}
